export let validateEmpty = function(txt, fieldName) {
    var result = {
        dirty: false,
        msg: ""
    };
    if ("" === txt) {
        result.dirty = true;
        result.msg = fieldName + "不能為空";
    }
    return result;
}

export let validateValueFormat = function(txt, fieldName) {
    var result = {
        dirty: false,
        msg: ""
    };
    if (/\#/.test(txt)) {
        result.dirty = true;
        result.msg = fieldName + "不能包含特殊字符#";
    }
    return result;
}

let validateUserName = function(currentUser, name) {
    if (currentUser.name == name) {
        return {
            dirty: true,
            msg: "您正在切換同一個賬號哦"
        };
    }
    return {
        dirty: false,
        msg: ""
    };
}

export let loginValidate = function(account, user) {

    let userNameValidateRes = validateEmpty(account.uname, "用戶名");
    let passwordValidateRes = validateEmpty(account.password, "密碼");
    let switchSameAccountRes = validateUserName(user.user, account.uname);
    let userNameFromatRes = validateValueFormat(account.uname, "用戶名");
    if (account.is_change && switchSameAccountRes.dirty) {
        return switchSameAccountRes;
    }
    if (userNameValidateRes.dirty) {
        userNameValidateRes.msg = "6-16位字元，區分大小寫";
        return userNameValidateRes;
    }
    if (userNameFromatRes.dirty) {
        userNameFromatRes.msg = "用戶名6-16位字元，區分大小寫";
        return userNameFromatRes;
    }
    if (passwordValidateRes.dirty) {
        passwordValidateRes.msg = "密碼6-16個字元，不能與帳號相同";
        return passwordValidateRes;
    }
    return {
        dirty: false,
        msg: ""
    }
}




export let registValidate = function(account) {
    let userNameValidateRes = validateEmpty(account.uname, "用戶名");
    let passwordValidateRes = validateEmpty(account.password, "密碼");
    let repasswordValidateRes = validateEmpty(account.repassword, "確認密碼");
    let userNameFromatRes = validateValueFormat(account.uname, "用戶名");
    if (userNameValidateRes.dirty) {
        userNameValidateRes.msg = "6-16位字元，區分大小寫";
        return userNameValidateRes;
    }
    if (userNameFromatRes.dirty) {
        userNameFromatRes.msg = "6-16位字元，區分大小寫";
        return userNameFromatRes;
    }
    if (passwordValidateRes.dirty) {
        passwordValidateRes.msg = "密碼6-16個字元，不能與帳號相同";
        return passwordValidateRes;
    }
    if (repasswordValidateRes.dirty) {
        repasswordValidateRes.msg = "6-16個字元，不能與帳號相同";
        return repasswordValidateRes;
    }
    if (account.password != account.repassword) {
        repasswordValidateRes.dirty = true;
        repasswordValidateRes.msg = "兩次輸入不一致，請重新確認密碼哦！";
    }
    return {
        dirty: false,
        msg: ""
    }
}


// WEBPACK FOOTER //
// ./src/store/validator.js